import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Import } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { CircularLoader } from '../CircularLoader';
import { Column, Row } from '../Layout';
import { Typography } from '../Typography/Typography';
import styles from './CsvStage.module.scss';
export const GetDropzoneContentTID = (parentTestId)=>getTestIds(parentTestId);
export const DropzoneContent = (param)=>{
    let { title, hint, limit, isUploading, testId } = param;
    const { DropzoneContentTestIds: TID } = useMemo(()=>GetDropzoneContentTID(testId), [
        testId
    ]);
    if (isUploading) {
        return /*#__PURE__*/ _jsx(CircularLoader, {
            testId: TID.Parsing()
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        alignItems: "center",
        testId: TID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Row, {
                className: styles.iconCircle,
                alignItems: "center",
                justifyContent: "center",
                children: /*#__PURE__*/ _jsx(Import, {
                    size: 24
                })
            }),
            /*#__PURE__*/ _jsxs(Column, {
                gap: 8,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        weight: "normal",
                        skin: "primary",
                        children: title
                    }),
                    hint && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        children: hint
                    }),
                    limit && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph3",
                        skin: "secondary",
                        children: limit
                    })
                ]
            })
        ]
    });
};
